import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from '../baseQueryV1';

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: baseQueryV1,
  tagTypes: ['DashboardStats'],
  endpoints: (builder) => ({
    getDashboardStatistics: builder.query({
      query: () => 'admin/dashboard/statistics',
      providesTags: ['DashboardStats'],
    }),
    getUpcomingEmployeeEvents: builder.query({
      query: ({ month, year } = {}) => {
        const params = new URLSearchParams();
        if (month && year) {
          params.append('month', month);
          params.append('year', year);
        }
        const qs = params.toString();
        return `admin/get-employee-upcoming-events${qs ? `?${qs}` : ''}`;
      },
      providesTags: ['DashboardStats'],
    }),
    getEmployeeEventsByMonth: builder.query({
      query: ({ month, year }) => `admin/get-employee-events-by-month?month=${month}&year=${year}`,
    }),
    getUpcomingBirthdays: builder.query({
      query: ({ month, year }) => `admin/get-upcoming-birthdays?month=${month}&year=${year}`,
    }),
    getUpcomingAnniversaries: builder.query({
      query: ({ month, year }) => `admin/get-upcoming-anniversaries?month=${month}&year=${year}`,
    }),
    getRecentActivity: builder.query({
      query: ({ page = 1, limit = 10, search = '' }) =>
        `admin/recent-activity?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
    }),
  }),
});

export const {
  useGetDashboardStatisticsQuery,
  useGetUpcomingEmployeeEventsQuery,
  useGetEmployeeEventsByMonthQuery,
  useGetUpcomingBirthdaysQuery,
  useGetUpcomingAnniversariesQuery,
  useGetRecentActivityQuery,
} = adminApi;
